import { useDispatch } from "react-redux"
import { addSectionDataArray, deleteSectionDataArray } from "../../Redux/Slices/sectionSlice"

export const FormNumList = ({_key,name,value,input,change}:any) => {
    const dispatch = useDispatch()
    
    const handleDelete = (input:any,index:any) => {
        const element = document.getElementById(`formListNode${index}`)
        if (element) {element.style.display  = "none"; element.id = `formListNode${index}deleted`}
        dispatch(deleteSectionDataArray({input,index}))
    }

    const addItem = (input:any) => {
        dispatch(addSectionDataArray({input}))
        var root = document.getElementById(`formNumList${_key}`)
        var indexam = root?.children.length

        const wrapperDiv = document.createElement("div");
        wrapperDiv.id = "formListNode" + indexam
        wrapperDiv.className = "input-group mb-3 newAdded"

        const input1 = document.createElement("input");
        input1.className = "form-control"
        input1.type = "text"
        input1.name = input + ':' + indexam + ':key'
        input1.onchange = change
        wrapperDiv.appendChild(input1)

        const input2 = document.createElement("input");
        input2.className = "form-control"
        input2.type = "number"
        input2.name = input + ':' + indexam + ':value'
        input2.onchange = change
        wrapperDiv.appendChild(input2)

        const btn = document.createElement("button");
        btn.className = "btn btn-danger"
        btn.type = "button"
        btn.innerHTML = '<i class="zmdi zmdi-delete"></i>'
        btn.onclick = function () {handleDelete(input,indexam)}
        wrapperDiv.appendChild(btn)

        if(root) root.appendChild(wrapperDiv)
    }

    return(
        <>
        <label htmlFor={`formNumList${_key}`} className="form-label">{name}</label>
            <div id={`formNumList${_key}`} >
                {value && value.map((val:any,index:number) => 
                    <div className="input-group mb-3" id={`formListNode${index}`} key={index}>
                        <input type="text" className="form-control" name={`${input}:${index}:key`} onChange={change} defaultValue={val.key} aria-label="کلید"/>
                        <input type="number" className="form-control" name={`${input}:${index}:value`} onChange={change}  defaultValue={val.value} aria-label="مقدار"/>
                        <button type="button" onClick={() => handleDelete(input,index)} className="btn btn-danger"><i className="zmdi zmdi-delete"></i></button>
                    </div>
                )}
            </div>
            <div className="d-grid mb-4">
                <button type="button" onClick={() => addItem(input)} className="btn btn-outline-primary">افزودن</button>
            </div>
        </>
    )
}

